// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/LaudoPublico_GenerateLinkInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /laudo_links/generate_link
 *
 * Authenticated endpoint. Receives an order_item_id + tipo and
 * gets-or-creates the PERSISTENT public link for that (item, tipo).
 */
import { registerContract } from './validate'

export interface LaudoPublico_GenerateLinkInput {
order_item_id: number
tipo: string
}

registerContract('LaudoPublico_GenerateLinkInput', {
  order_item_id: { type: 'number',  required: true },
  tipo:          { type: 'string',  required: true },
})
